export default __webpack_public_path__ + "static/media/railway_alert_white_24dp.f27296c0.svg";